import { render, staticRenderFns } from "./ChatHeadTooltip.vue?vue&type=template&id=251b4f17&scoped=true"
import script from "./ChatHeadTooltip.vue?vue&type=script&lang=js"
export * from "./ChatHeadTooltip.vue?vue&type=script&lang=js"
import style0 from "./ChatHeadTooltip.vue?vue&type=style&index=0&id=251b4f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b4f17",
  null
  
)

export default component.exports